// src/app/components/newsletter/newsletterService.js
//
// Abonnement à la newsletter.
//
// ⚠️ SERVICE DE TEST — il n'existe pas encore d'API côté back. Rien n'est
// enregistré : l'appel simule un délai réseau puis réussit. Quand l'API
// existera, seul `subscribeToNewsletter` change ; il doit résoudre en cas de
// succès et rejeter une NewsletterError sinon.
//
// Pour tester l'état d'erreur en local : une adresse en « @erreur.test ».

const MOCK_DELAY_MS = 700;

export class NewsletterError extends Error {
  constructor(code, message) {
    super(message || code);
    this.name = "NewsletterError";
    /** "invalid_email" | "network" | "unknown" */
    this.code = code;
  }
}

/* Contrôle volontairement souple : le serveur reste juge. On écarte seulement
   ce qui ne peut pas être une adresse. */
export const isValidEmail = (value) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(value || "").trim());

export async function subscribeToNewsletter(email) {
  const normalized = String(email || "").trim().toLowerCase();
  if (!isValidEmail(normalized)) {
    throw new NewsletterError("invalid_email");
  }

  await new Promise((resolve) => setTimeout(resolve, MOCK_DELAY_MS));

  if (normalized.endsWith("@erreur.test")) {
    throw new NewsletterError("network");
  }

  return { email: normalized, status: "subscribed" };
}
